export default "__VITE_ASSET__9ELNFdfw__ 480w, __VITE_ASSET__0eIMsLx___ 768w, __VITE_ASSET__V_SlgPYi__ 960w";